import React from 'react';

import AccountPlanContainer from '@totem/components/accountPlan/AccountPlanContainer';
import OrgChartLayout, {
  OrgChartExtra,
} from '@totem/components/administration/account/orgChart/orgChartLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

// The org chart is drawn from the account plan's stakeholders, so it shares the plan's data layer.
const OrgChartPage = () => (
  <ContentLayout>
    <AccountPlanContainer>
      <IBCard isCovered title="Org Chart" extra={<OrgChartExtra />}>
        <OrgChartLayout />
      </IBCard>
    </AccountPlanContainer>
  </ContentLayout>
);

export default OrgChartPage;
